module.exports = __webpack_public_path__ + "img/history-gray.4acd09d9.svg";